import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Row,
  Col,
  Select,
} from "antd";

import get from "lodash/get";
import map from "lodash/map";
import { connect } from "react-redux";

import {
  updateSubjectIssueRequest,
  createSubjectIssueRequest,
} from "../../api/requests";

import {
  getSubjectIssuesCreatePermission,
  getSubjectIssuesUpdatePermission,
} from "../../reducers/user/selectors";

import classes from "./QualityControlForm.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

class QualityControlForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      showID: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const item = { ...values };

          if (this.props.id) {
            await updateSubjectIssueRequest(this.props.id, item);
          } else {
            await createSubjectIssueRequest({
              ...item,
              subject_id: this.props.subject_id,
              custom_form_id: get(this.props, "custom_form.id"),
            });
          }

          this.setState({
            isLoading: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator } = this.props.form;
    const {
      subjectIssuesUpdatePermission,
      subjectIssuesCreatePermission,
      id,
    } = this.props;

    const isEditable = id
      ? subjectIssuesUpdatePermission
      : subjectIssuesCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              this.props.i18n.t("NamespaceQualityControlForm:Edit")
            ) : (
              <div>
                {this.props.i18n.t("NamespaceQualityControlForm:Add Issue")}{" "}
                <Badge
                  style={{ backgroundColor: "#2968AE" }}
                  count={get(this.props, "custom_form.name")}
                />{" "}
              </div>
            )}
          </h4>

          {get(this.props, "event.name") && (
            <div style={{ marginBottom: "12px" }}>
              <Badge
                count={get(this.props, "event.name")}
                style={{ backgroundColor: "#2968AE" }}
              />
            </div>
          )}

          <Row gutter={12}>
            {!id && (
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("Type")}</b>
                  <Form.Item>
                    {getFieldDecorator("type", {
                      initialValue: get(this.props, "type"),
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(
                      <Select
                        disabled={!isEditable}
                        style={{ width: "100%" }}
                        allowClear
                      >
                        <Option value="form_soft_validation">
                          {this.props.i18n.t("NamespaceQualityControlForm:Form soft validation")}
                        </Option>
                        <Option value="conflicting_data">
                          {this.props.i18n.t("NamespaceQualityControlForm:Conflicting data")}
                        </Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}
            {id && (
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("Status")}</b>
                  <Form.Item>
                    {getFieldDecorator("status", {
                      initialValue: get(this.props, "status"),
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    })(
                      <Select
                        disabled={!isEditable}
                        style={{ width: "100%" }}
                        allowClear
                      >
                        <Option value="reviewed">{this.props.i18n.t("NamespaceQualityControlForm:Reviewed")}</Option>
                        <Option value="new">{this.props.i18n.t("NamespaceQualityControlForm:New")}</Option>
                        <Option value="answered">{this.props.i18n.t("NamespaceQualityControlForm:Answered")}</Option>
                        <Option value="closed">{this.props.i18n.t("NamespaceQualityControlForm:Closed")}</Option>
                        <Option value="deleted">{this.props.i18n.t("NamespaceQualityControlForm:Deleted")}</Option>
                      </Select>
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}
            <Col span={24}>
              <label>
                <b>{this.props.i18n.t("Comment")}:</b>
                <Form.Item>
                  {getFieldDecorator("comments", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "comments", ""),
                  })(
                    <Input.TextArea
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("Comment")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {id && (
            <div style={{ marginBottom: '18px' }}>
              <b>{this.props.i18n.t("Created by")}</b>:{" "}
              {get(this.props, "created_by_user.username")}
              <br />
              {get(this.props, "last_updated_by_user.username") && (
                <div>
                  <b>{this.props.i18n.t("Last updated by")}</b>:{" "}
                  {get(this.props, "last_updated_by_user.username")}
                </div>
              )}
            </div>
          )}

          <div>
            {map(
              Object.keys(get(this.props, "field_errors_data", {})),
              (key) => (
                <Alert
                  style={{ margin: "8px 0" }}
                  type="warning"
                  message={
                    <div>
                      <b>{key}</b>

                      <br />
                      {map(
                        get(this.props, `field_errors_data.${key}`, []),
                        (val, i) => (
                          <div key={i}>{val}</div>
                        )
                      )}
                    </div>
                  }
                />
              )
            )}
          </div>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  subjectIssuesCreatePermission: getSubjectIssuesCreatePermission(state),
  subjectIssuesUpdatePermission: getSubjectIssuesUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "customer" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(QualityControlForm))
);



// WEBPACK FOOTER //
// ./src/components/QualityControlForm/QualityControlForm.js